<template>
	<div class="container" v-if="loaded && !survey_result.complete">
    <div id="breadCrumb" class=" col content pt-2" v-if="show_breadcrumb">
			<router-link :to="{ name: 'therapy' }" class="smooth-menu">{{ $t('courses.header')}}</router-link> >
			<router-link v-if="enrollment" :to="{ name: 'therapy.display', params: {enrol_id: enrollment.id} }" class="smooth-menu">{{enrollment.program.display_name}}</router-link> >
			{{ surveyTitle }}
		</div>

		<div id="content" class="col p-0" v-if="(survey_result != null && survey_result.survey != null && survey_result.survey.page == null) || contentViewed">
			<SurveyComp :survey="surveyModel" :key= "survey_key" ></SurveyComp>

			<span style="clear: both;" />

			<div class="panel-footer card-footer pt-4">
				<div>
					<div class="float-left" v-if="(survey_result != null && survey_result.survey != null && survey_result.survey.page != null)"><button type="button" class="btn btn-primary otu-blue-bg border-0 p-2" @click="navigate(false);">&lt; {{ $t('previous')}}</button></div>
				</div>
				<br style="clear: both;" />
			</div>
		</div>
		<div id="content" class="col p-0" v-if="(survey_result != null && survey_result.survey != null && survey_result.survey.page != null && !contentViewed)">
			<div class="sv_main sv_bootstrap_css">
				<div class="sv_container">
					<div class="panel-heading card-header">
						<h3><span style="position: static">{{ survey_result.survey.page.title }}</span></h3>
					</div>
					<div class="sv_qstn panel-body card-block mt-4 content-body" v-html="survey_result.survey.page.body"></div>

					<Resources v-if="Object.keys(survey_result.survey.page.resources).length > 0" :files="survey_result.survey.page.resources" />

					<div class="panel-footer card-footer">
						<span style="clear: both;" />
						<div>
							<div class="float-right"><button name="" type="button" class="btn btn-primary otu-blue-bg border-0 p-2" @click="navigate(true);">{{ $t('next')}} &gt;</button></div>
						</div>
						<br style="clear: both;" />
					</div>
				</div>
			</div>
		</div>

		<div id="content" v-if="survey_result == null || survey_result.survey == null">{{ $t('survey_load_error')}}</div>

	</div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'

import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { mapCommonFilters } from '@/lib/filters.js';
import { errHandler } from '@/lib/handlers';

import * as SurveyVue from 'survey-vue';

var SurveyComp = SurveyVue.Survey;
SurveyComp.cssType = "bootstrap";
SurveyVue.JsonObject.metaData.addProperty('survey', {name: '_id:number', default: {} });
SurveyVue.JsonObject.metaData.addProperty('questionbase', {name: '_id:number', default: {} });
SurveyVue.JsonObject.metaData.addProperty('questionbase', {name: '_number:number', default: {}, readOnly: true });
SurveyVue.JsonObject.metaData.addProperty('itemvalue', {name: '_id:number', default: {}, readOnly: true, visible: false });


import Survey from '@/models/survey';
import ResultEntry from '@/models/result_entry';
import ResultEntryValue from '@/models/result_entry_value';

export default {
  components: {
		SurveyComp,
		Resources: () => import ('@/components/Resources'),
	},
	data () {
		return {
			surveyModel: new SurveyVue.Model(),
			contentViewed: false,
      survey_key: 0
		}
	},
	props: ['enrol_id', 'surveylink_id', 'task_id', 'survey_result', 'show_breadcrumb', 'loaded'],
  watch: {
    '$root.$i18n.locale': function() {
      this.loadSurvey ();
      this.survey_key += 1;
    },
  },
	computed: {
		enrollment () {
			
			return this.$store.state.programs.enrollment;
		},
		surveyJSdata () {
			return (this.survey_result.survey) ? this.survey_result.survey.toSurveyJS(true, ((this.survey_result.survey_link)?this.survey_result.survey_link.display_title:null)) : null;
		},
		resultJSdata () {
			return this.survey_result.resultJSdata();
		},
		surveyTitle () {
			//means it is a in program quiz survey task, show the display title from the task.
			if (this.task_id) {
				var task_title = this.getDisplayTitleForProgramTask();
				if (task_title) {
					return task_title;
				}			
			}
			// if(this.getDisplayTitleForProgramTask()){
			// 	return this.getDisplayTitleForProgramTask()
			// }
			
			
			return (this.survey_result.survey_link && this.survey_result.survey_link.display_title) ? ((this.survey_result.survey_link.display_title.trim().length > 0) ? this.survey_result.survey_link.display_title : this.survey_result.survey.title) : this.survey_result.survey.title;
		},
		// currentLanguage () {
        //     return i18n.locale;
        // }
	},
	mounted () {
		//this.loadSurvey();
	},
	methods: {
		...mapActions(['submitResultEntry', 'completeSurvey']),
		navigate (status) {
			this.contentViewed = status;
			this.$nextTick(function() {
				this.scrollToTop();
			});
		},
		scrollToTop () {
			let top = document.querySelector('#content').getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop)
			window.scrollTo({ top: top, behavior: 'smooth' });
		},
		loadSurvey () {

			let model = new SurveyVue.Model(this.surveyJSdata);
    		model.data = this.resultJSdata;
			model.isCompleted = this.survey_result.complete;

      model.locale = this.$root.$i18n.locale;

			// Language Override
			model.completeText = this.$t('courses.survey_complete_btn');


			model.UpdateResult = async (sender, options) => {
				let q              = options.question;
				let tmp            = this.buildResultValues(q);
				let resultEntries  = {"data":[], "included":[]};

				for (const result_entry of tmp) {
					let tmp2 = result_entry.toJSONapi();
					resultEntries["data"].push(tmp2["data"]);
					resultEntries["included"] = resultEntries["included"].concat(tmp2["included"]);
				}

				let resp = await this.submitResultEntry({enrol_id: this.enrollment.id, surveylink_id: this.surveylink_id, task_id: this.task_id, result_id: this.survey_result.id, data: resultEntries}); //.catch(errHandler);

			};

			model.onValueChanged.add ( (sender, options) => {
				model.UpdateResult(sender, options)
			});

			model.onComplete.add ( async (sender, options) => {
				let tmp = [];
				let resultEntries = {"data":[], "included":[]};

				for (const varname of Object.keys(this.surveyModel.questionHashes.valueNames) ) {
					tmp = tmp.concat(this.buildResultValues(this.surveyModel.questionHashes.valueNames[varname][0]));
				}

				for (const result_entry of tmp) {
					let tmp2 = result_entry.toJSONapi();
					resultEntries["data"].push(tmp2["data"]);
					resultEntries["included"] = resultEntries["included"].concat(tmp2["included"]);
				}

				try {
					this.completeSurvey({enrol_id: this.enrollment.id, surveylink_id: this.surveylink_id, task_id: this.task_id, data: resultEntries}).then((v) => {
						this.$emit('complete');
					});
				} catch (err) {
					errHandler(err);
					this.$emit('complete');
				}
			});

			
			//means it is a in program quiz survey task, show the display title from the task.
			if (this.task_id) {
				var task_title = this.getDisplayTitleForProgramTask();
				if (this.getDisplayTitleForProgramTask()) {
					model.title = task_title;
				}
			}
			// if(this.getDisplayTitleForProgramTask()){
			// 	model.title = this.getDisplayTitleForProgramTask()
			// }
			this.surveyModel = model;
		},
		buildResultValues(q) {
			if (undefined == q.value) return [];

			let t            = q.getType();
			let id           = q._id;
			let result_entry = Object.values(this.survey_result.result_entries).find( x => x.question_id == id )

			if (null == result_entry) {
				result_entry = new ResultEntry({id: (-1*id), questionId: id })
			}

			if (t == 'matrix') {
				let bq = this.survey_result.survey.questions[id];
				let resp = [];
				let revId = (-1000 * id);

				let val = q.value;

				for (const varname of Object.keys(val)) {
					let cq = Object.values(bq.rows).find( x => x.varname == varname);
					result_entry = Object.values(this.survey_result.result_entries).find( x => x.question_id == cq.id )
					if (null == result_entry) {
						revId = (cq.id * -1)
						result_entry = new ResultEntry({id: revId, question: cq, questionId: cq.id })
					}

					let toDelete = Object.keys(result_entry.result_entry_values);
					let value = val[varname]
					let question_choice = null;

					question_choice = (value instanceof Object && '_id' in value) ? value : q.columns.find( e => parseInt(e.itemValue) == parseInt(value) );
					let rev = Object.values(result_entry.result_entry_values).find( x =>  x.question_choice_id == question_choice._id)
					if (null == rev) {
						revId = (revId * 1000) - 1;
						result_entry.result_entry_values[revId] = new ResultEntryValue({id: revId, questionChoice: question_choice, questionChoiceId: question_choice._id});

						// Remove previous entry before submission so it's deleted
						// If we need matrix dropdown options, this will need to be fixed
						for (const value of toDelete) {
							delete result_entry.result_entry_values[value];
						}
					}

					resp.push(result_entry);
				}
				return resp;

			} else if (q.value instanceof Array) {
				let revId = -1000 * id;
				let toDelete = Object.keys(result_entry.result_entry_values);
				if (q.value.length) {
					for (const value of q.value) {

						let question_choice = q.choices.filter((e) => {
							let _id = e._id
							if (e.value == value) { return _id }
							return null
						});

						let rev = null;
						if (question_choice.length == 0) {
							result_entry.result_entry_values[revId] = new ResultEntryValue({id: revId, questionChoiceId: question_choice[0]._id});
						} else {
							rev = Object.values(result_entry.result_entry_values).find( x =>  x.question_choice_id == question_choice[0]._id)
							if (null == rev) {
								result_entry.result_entry_values[revId] = new ResultEntryValue({id: revId, questionChoiceId: question_choice[0]._id});
								revId--;
							} else {
								toDelete = toDelete.filter( item => rev.id != item );
							}
						}
					}

					// Remove previous entry before submission so it's deleted
					for (const value of toDelete) {
						delete result_entry.result_entry_values[value];
					}
				}
			} else {
				if (undefined != q.choices) {

					let toDelete = Object.keys(result_entry.result_entry_values);
					let question_choice = q.choices.filter((e) => {
						let _id = e._id
						if (e.value == q.value) { return _id }
						return null
					});

					let rev = null;
					if (question_choice.length > 0) {
						rev = Object.values(result_entry.result_entry_values).find( x =>  x.question_choice_id == question_choice[0]._id)
						if (null == rev) {
							result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue({id: (-1000 * id), questionChoiceId: question_choice[0]._id});
						} else {
							toDelete = toDelete.filter( item => rev.id != item );
						}
					}

					// Remove previous entry before submission so it's deleted
					for (const value of toDelete) {
						delete result_entry.result_entry_values[value];
					}

				} else {
					let toDelete = Object.keys(result_entry.result_entry_values);
					for (const value of toDelete) {
						delete result_entry.result_entry_values[value];
					}

					switch (t) {
						case 'boolean':
							result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue({ id: (-1000 * id), value: (q.value == 'true'), text: q.value });
							break;

						case 'rating':

							if ( 'rateValues' in q && q.rateValues.length > 0) {
								let question_choice = q.rateValues.filter((e) => {
									let _id = e._id;
									if (e.value == q.value) { return _id };
									return null;
								})

								if (question_choice.length == 0) {
									result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue( { id: (-1000 * id), value: parseInt(q.value), text: q.value } );
								} else {
									result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue( { id: (-1000 * id), questionChoiceId: question_choice[0]._id });
								}
							}
							else result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue( { id: (-1000 * id), value: parseInt(q.value), text: q.value });

						default:
							if (Object.keys(result_entry.result_entry_values).length == 1) {
								let rev = result_entry.result_entry_values[Object.keys(result_entry.result_entry_values)[0]]
								rev.text = q.value;
							} else {
								result_entry.result_entry_values[(-1000 * id)] = new ResultEntryValue({id: (-1000 * id), text: q.value});
							}
					}
				}
			}

			return [result_entry];
		},
		resetPosition() {
			this.$nextTick(function() {
				this.scrollToTop();
			});
		},
		getDisplayTitleForProgramTask(){
			if (this.$store.state.programs.stage.hasOwnProperty('tasks')) {
				const localTask = this.$store.state.programs.stage.tasks[this.task_id]
				if (localTask.hasOwnProperty('item_type') && localTask.item_type === "survey_task" && localTask.display_title){
					return localTask.display_title
				}
			}
			return null; 
		}
	}
}
</script>
